export default __webpack_public_path__ + "static/media/step4.86cb3f72.gif";